export default (that) => [
  {
    field: 'seq',
    width: 50,
    align: 'center',
    fixed: 'left',
    type: 'seq',
  },
  {
    title: that.$l('INDEX.table_label_image') || '图片',
    field: 'defaultImageUrl',
    headerAlign: 'center',
    align: 'left',
    fixed: 'left',
    width: 80,
    slots: { default: 'defaultImageUrl' },
  },
  {
    title: that.$l('table_label_displayName') || '产品名称',
    field: 'goodsName',
    headerAlign: 'center',
    align: 'left',
    fixed: 'left',
    minWidth: 220,
    slots: { default: 'displayName' },
    showHeaderOverflow: true,
  },
  {
    title: that.$l('table_label_displayNo') || '产品编号',
    field: 'amzSkuNo',
    headerAlign: 'center',
    align: 'left',
    minWidth: 180,
    slots: { default: 'displayNo' },
    showHeaderOverflow: true,
  },
  {
    title: that.$l('table_label_inCtnQty') || '装箱入数',
    field: 'inCtnQty',
    align: 'center',
    minWidth: 90,
    formatter: ({ cellValue }) => that.format(cellValue),
    showHeaderOverflow: true,
  },
  {
    title: that.$l('table_label_qty') || '需求数量',
    field: 'qty',
    align: 'center',
    minWidth: 90,
    isTotalColumn: true,
    formatter: ({ cellValue }) => that.format(cellValue),
    showHeaderOverflow: true,
  },
  {
    title: that.$l('table_label_ctnQty') || '箱数',
    field: 'ctnQty',
    align: 'center',
    minWidth: 90,
    isTotalColumn: true,
    formatter: ({ cellValue }) => that.format(cellValue),
    showHeaderOverflow: true,
  },
  {
    title: that.$l('table_label_ftyPrice') || '采购单价',
    field: 'ftyPrice',
    align: 'center',
    minWidth: 90,
    formatter: ({ cellValue }) => that.format(cellValue),
    showHeaderOverflow: true,
  },
  {
    title: that.$l('table_label_totalFtyPrice') || '采购小计',
    field: 'totalFtyPrice',
    align: 'center',
    minWidth: 90,
    formatter: ({ cellValue }) => that.format(cellValue),
    showHeaderOverflow: true,
  },
  {
    title: that.$l('table_label_firstQty') || '首批上架数量',
    field: 'firstQty',
    align: 'center',
    minWidth: 100,
    formatter: ({ cellValue }) => that.format(cellValue),
    showHeaderOverflow: true,
  },
  {
    title: that.$l('table_label_firstSaleDay') || '首批上架日期',
    field: 'firstSaleDay',
    width: 100,
    align: 'center',
    showHeaderOverflow: true,
  },
  {
    title: that.$l('INDEX.table_cargoReadyDay') || '工厂货好日期',
    field: 'cargoReadyDay',
    width: 100,
    align: 'center',
    showHeaderOverflow: true,
  },
]
